import { IsNotEmpty, IsNumber, IsPositive } from 'class-validator';

export class InvoiceBillingQueueForDispatchDto {
  @IsNotEmpty()
  @IsNumber()
  @IsPositive()
  invoiceBillingId: number;
}